import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();
    if (loading)
        return (
            <div className="min-h-screen flex items-center justify-center bg-slate-50">
                <div className="overline" data-testid="auth-loading">Chargement…</div>
            </div>
        );
    if (!user) return <Navigate to="/login" replace />;
    return children;
}
